<template>
  <div class="content-container">
    <BannerSearch> </BannerSearch>
    <div class="content">
      <div class="content-box">
        <SideTap class="win" :title="this.$route.hash" :keys="tags" :pad="16" :lheight="'30'" :size="'20'" :padding="25" 
          :width="'270px'"></SideTap>
        <!-- <SideTap class="pad" :title="this.$route.hash" :keys="tags" :padding="70"></SideTap> -->
        <div class="title-container">
          <div class="title-innerbox">

            <div>

              <ul class="title-ul" id="test">
                <li class="title-li" v-for="(li, index) in list.posts" @click="goArticle(li.id)" :key="index" v-html="li.title.rendered">
                </li>

              </ul>

            </div>


            <!-- <span class="show-btn" @click="goDetail(item)">{{ $t('m.topic.all') }}</span> -->
          </div>
        </div>
      </div>

    </div>
    <Featured></Featured>
  </div>
</template>

<script>
import Featured from "../components/Featured.vue";
import SideTap from "../components/SideTap.vue";
import BannerSearch from "../components/BannerSearch.vue";

export default {
  components: { Featured, SideTap, BannerSearch },
  data() {
    return {
      // tags: ["KNOW ISSUES", "GENERAL", "SHOP/PAY", "ACCOUNTS", "TECH ISSUES", "中文测试"],
      tags: [],
      title: '',
      article: [],
      list: [],
    };
  },
  mounted() {

    if (!this.$route.hash) {
      console.log(this.$store.state.class[0].id);
      this.$router.push('/faq#topic=' + this.$store.state.class[0].id)
    }
    var count = 0
    let timer = setInterval(() => {
      count++
      if (count >= 50) {
        clearInterval(timer)
      }
      if (this.$store.state.class != '') {
        this.$store.state.class.map(item => {
          this.tags.push(item.name)
        })

        console.log(this.$store.state.class);
        this.list = this.$store.state.class

        this.$store.state.class.map(res => {

          if (res.id == this.$route.hash.replaceAll('#topic=', '')) {
            this.list = res
          }
        })
        console.log();
        clearInterval(timer)
      }
    }, 100);


  },
  methods: {
    clickArt(item) {
      console.log("111", item);
      this.$store.state.class.map(res => {
        if (res.name == item) {
          this.list = res
        }
      })
      console.log(this.list);
    },
    goArticle(artPath) {
      console.log(artPath);
      this.$router.push({
        path: '/article',
        query: {
          'id': artPath
        }
      })
    },
    goDetail(item) {
      this.$router.push({
        path: '/faq/'
          + item.id
            .replaceAll(" ", "-")
            .replaceAll("/", "&")
            .replaceAll("#", "")
            .toLowerCase().replaceAll('topic=', '')

      });
    },
    showList() {
      if (document.getElementById("test").style.marginBottom == "621px") {
        document.getElementById("test").style.marginBottom = "30px";
      } else {
        document.getElementById("test").style.marginBottom = "621px";
      }
    },
  },
  created() { },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/content.scss";
</style>